var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResource(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 42,
    viewBox: "0 0 46 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1639 -141) translate(0 120)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1639 21)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.5,
    transform: "translate(15.02 5)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.609,
    cy: 4.263,
    rx: 4.207,
    ry: 4.263
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.248 19.182v2.132h3.155L4.454 31.97h6.31l1.052-10.656h3.155v-3.197c-.002-2.558-1.295-4.936-3.428-6.304-2.133-1.367-4.808-1.533-7.089-.439"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.97 19.182v2.132h-3.154L10.764 31.97h-6.31L3.403 21.314H.248v-3.197c.001-2.558 1.295-4.936 3.427-6.304 2.133-1.367 4.808-1.533 7.09-.439M7.609 10.657L7.609 17.051M7.609 10.657L7.609 17.051"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResource);
export default __webpack_public_path__ + "static/media/resource.cd5cc323b97bcd9aa1425dfebe4d0c94.svg";
export { ForwardRef as ReactComponent };